export const SECTION_ID = {
    HOME: '_home',
    ABOUT_ME: '_about_me',
    EDUCATION: '_education',
    PROJECTS: '_projects',
    CONTACT_ME: '_contact_me'
}

export const THEME = {
    DARK: 'darkMode',
    LIGHT: 'lightMode'
}

export const LANG = {
    ES: 'es',
    EN: 'en'
}

export const LOCAL_STORAGE = {
    THEME: 'theme',
    LANG: 'lang'
}